<template>
  <cTable
    ref="table"
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
    <!-- <template #TEST="{field,row}">
        <Button>{{row[field.key]}}</Button>
      </template> -->
    <template #DETAILS="{visible,params}">
      <Tracker v-if="visible" :statusId="params.row.airway_number"></Tracker>
    </template>
    <template #header>
      <Tabs v-model="tabName" @on-click="handleTab">
        <TabPane :label="$t('n_process')" name="NO" />
        <TabPane :label="$t('y_process')" name="YES" />
      </Tabs>
    </template>

    <template #UPLOADED="{params}">
      <Row v-if="params.img && params.img.length" type="flex" justify="start">
        <Col
          v-for="item in params.img"
          :key="item.id"
          span="4"
          class="demo-upload-list"
          style="padding:0;margin:0;font-size:0;margin-right:10px;"
        >
          <img style="width:100%;" :src="item.src" />
          <div class="demo-upload-list-cover" style="padding:0;margin:0">
            <Icon type="ios-eye-outline" @click.native="openImg(item.src)">
            </Icon>
            <Icon
              v-if="!params.is_delete"
              type="ios-trash-outline"
              @click.native="delUploadFile(item.id, params)"
            >
            </Icon>
          </div>
        </Col>
      </Row>
      <template v-if="params.doc && params.doc.length">
        <div
          @click="openFile(item.src)"
          v-for="item in params.doc"
          :key="item.id"
          class="div-hover"
        >
          <span> {{ item.name }}</span>
          <Icon
            v-if="!params.is_delete"
            @click.stop="delUploadFile(item.id, params)"
            class="icon-close"
            size="20"
            type="ios-close"
          />
        </div>
      </template>
    </template>
  </cTable>
</template>

<script>
import { getAllClient } from "@/api/user/client";
import { getUser } from "@/api/user/internal";
import {
  getOrderDetails,
  getError,
  getRecord,
  getOrderStatus,
  getFinishError,
  addRemark,
  remarkList
} from "@/api/order/list";
import { getSelectType } from "@/api/public";
import { getCountry } from "@/api/system/country";
import Tracker from "@/base/order_tracker";
import { proxyErr, pushProxy, saveProxy } from "@/api/order/proxy";
import cTable from "@/base/common/index";
export default {
  name: "goods",
  components: {
    cTable,
    Tracker
  },
  mounted() {},
  methods: {
    handleTab(tab) {
      console.log(this);
      this.$refs["table"].tabName = this.tabName;
      this.$refs["table"].getList();
    }
  },
  data() {
    let errorObj = [
        "orther",
        "finished",
        "byCustomer",
        "byOverseasWarehouseListed",
        "byOverseasWarehousePicking",
        "byCallCenter",
        "byService"
      ],
      codType = [
        {
          value: "NCND",
          label: "COD"
        },
        {
          value: "NOR",
          label: "PP"
        }
      ],
      podType = ["NO", "YES"],
      pickupList = [
        {
          value: this.$t("YES"),
          label: "YES"
        },
        {
          value: this.$t("NO"),
          label: "NO"
        }
      ];

    return {
      tabName: "NO",
      methods: {
        list: params => {
          params["is_process"] = this.tabName;
          return getError(params);
        },
        getAllClient,
        getUser,
        getSelectType,
        getFinishError,
        addRemark,
        remarkList
        // getDetails
      },
      config: {
        height: 630
      },
      modals: {
        finish: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("getFinishError", row, true)
                .then(res => {
                  this.$page.getList();
                  this.close();
                });
            }
          },
          config: {
            rules: {
              status: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
              remarks: [
                {
                  required: false,
                  message: "cannot be empty",
                  trigger: "bulr"
                }
              ]
            },
            formBind: {
              labelWidth: 100
            },
            title: this.$t("finish") + this.$t("abnormal"),
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          grid: [{ status: 24 }, { remarks: 24 }],
          fields: [
            {
              key: "status",
              name: () => this.$t("tip"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("tip");
              },
              options: [
                {
                  value: 7,
                  label: "agentProcessed"
                },
                {
                  value: 1,
                  label: "finished"
                }
              ],
              config: {
                label: ({ row }) => {
                  return this.$t(row.label);
                }
              }
            },
            {
              key: "remarks",
              name: () => this.$t("order_desc"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("order_desc");
              },
              bind: {
                type: "textarea",
                rows: 5
              }
            }
          ]
        },
        addRemark: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("addRemark", row, true)
                .then(res => {
                  this.$page.getList();
                  this.close();
                });
            }
          },
          config: {
            rules: {
              remarks: [
                {
                  required: true,
                  message: "remarks be empty",
                  trigger: "bulr"
                }
              ]
            },
            formBind: {
              labelWidth: 100
            },
            title: this.$t("add") + this.$t("order_desc"),
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          grid: [{ remarks: 24 }],
          fields: [
            {
              key: "remarks",
              name: () => this.$t("order_desc"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("order_desc");
              },
              bind: {
                type: "textarea",
                rows: 5
              }
            }
          ]
        },
        show: {
          contentSlot: "DETAILS",
          config: {
            modalBind: {
              draggable: true,
              transfer: true,
              width: 600
            }
          },
          footer: { show: () => false }
        },
        showRemark: {
          config: {
            listFn: "remarkList",
            modalBind: {
              width: 600
            },
            title: "order_desc",
            modalContentBind: {
              style: "height:60vh;overflow-x:hidden;overflow-y:auto;"
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          footer: {
            show: false
          },
          fields: [],
          table: {
            config: {
              align: "center",
              height: 500
            },
            fields: [
              {
                name: () => this.$t("serviceAccount"),
                key: "operator_name",
                align: "center",
                tooltip: true,
                minWidth: 100
              },
              {
                name: () => this.$t("order_desc"),
                key: "remarks",
                align: "center",
                tooltip: true,
                minWidth: 100
              },
              {
                name: () => this.$t("addTo") + this.$t("time"),
                key: "remarks_time",
                align: "center",
                tooltip: true,
                minWidth: 100,
                methods: {
                  render({ value }) {
                    return ~~value ? this.format.timeFormat(value * 1000) : "-";
                  }
                }
              }
            ]
          }
        },
        detail: {
          slots: ["UPLOADED"],
          methods: {
            ok({ row, close }) {
              let newData = {
                type: "detail",
                feedback_number: row.feedback_number,
                staff_id: row.staff_id,
                content: row.content,
                feedback_id: row.id,
                files: row.files
              };
              let data = new FormData();
              for (const key in newData) {
                if (key === "files" && newData[key]) {
                  for (var i = 0; i < newData[key].length; i++) {
                    data.append("files[]", newData[key][i]); // 文件对象
                  }
                } else if (key === "staff_id" && newData[key]) {
                  for (var i = 0; i < newData[key].length; i++) {
                    data.append("staff_id[]", newData[key][i]); // 文件对象
                  }
                } else {
                  if (newData[key]) {
                    data.append(key, newData[key]);
                  }
                }
              }
              let obj = {
                method: "get",
                feedback_id: row.id
              };
              this.$page
                .handleRequestMethods("addAssistPlatform", data, true)
                .then(() => {
                  this.getList(obj);
                  this.$store.commit("remindFun", true);
                  this.$refs["form"].clear();
                  // close();
                });
            }
          },
          footer: {
            ok: {
              name: this.$t("order_submit")
            }
          },
          config: {
            listFn: "detail",
            title: "detail",
            modalContentBind: {
              style: "height:80vh;overflow-x:hidden;overflow-y:auto;"
            },
            modalBind: {
              width: "80%",
              styles: {
                top: "30px"
              }
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              content: [
                {
                  required: true,
                  message: "airway number cannot be empty",
                  trigger: "blur"
                }
              ]
              // staff_id: [
              //   {
              //     required: false,
              //     type: "array",
              //     message: "staff cannot be empty",
              //     trigger: "blur"
              //   }
              // ]
            }
          },
          grid: [
            // {
            //   name: () => this.$t("feedbackArea"),
            //   span: 10,
            //   children: [
            //     {
            //       cause: 24
            //     },
            //     {
            //       message: 24
            //     },
            //     {
            //       uploaded: 24
            //     }
            //   ]
            // },
            {
              name: () => this.$t("FollowArea"),
              span: 24,
              children: [
                {
                  department: 8,
                  staff_id: 16
                },
                {
                  content: 24
                },
                {
                  airway_number: 24
                },
                {
                  files: 24
                }
              ]
            }
            // { cause: 10, department: 6, staff_id: 8 },
            // { message: 10, content: 14 },
            // { uploaded: 10, files: 14 }
            // { leftNull: 10, files: 14 }
          ],
          fields: [
            {
              name: () => this.$t("assistDepartment"),
              key: "department",
              component: "Select",
              bind: {
                multiple: true
              },
              placeholder: () =>
                this.$t("select") + this.$t("assistDepartment"),
              options: [],
              methods: {
                "on-change"({ fields, value, row }) {
                  fields.forEach(async item => {
                    if (item.key === "staff_id") {
                      getUserList({ department: value }).then(res => {
                        item.options = res.data.payload;
                      });
                      row.staff_id = [];
                      this.$forceUpdate();
                    }
                  });
                }
              }
            },
            {
              name: () => this.$t("needAssistPerson"),
              key: "staff_id",
              component: "Select",
              bind: {
                multiple: true
              },
              placeholder: () =>
                this.$t("select") + this.$t("needAssistPerson"),
              options: []
            },
            {
              name: () => this.$t("ReasonFeedback"),
              key: "cause",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("ReasonFeedback"),
              bind: {
                type: "textarea",
                autosize: { minRows: 1, maxRows: 4 }
              },
              disabled: true
            },
            {
              name: () => this.$t("need") + this.$t("AssistContent"),
              key: "message",
              component: "Input",
              placeholder: () =>
                this.$t("enter") + this.$t("need") + this.$t("AssistContent"),
              disabled: true,
              bind: {
                type: "textarea",
                autosize: { minRows: 1, maxRows: 4 }
              }
            },
            {
              name: () => this.$t("FollowCase"),
              key: "content",
              component: "Input",
              bind: {
                type: "textarea",
                rows: 4
              },
              placeholder: () => this.$t("enter") + this.$t("FollowCase")
            },
            {
              name: () => this.$t("orderNum"),
              key: "airway_number",
              component: "Input",
              bind: {
                type: "textarea",
                rows: 2
              },
              placeholder: () => this.$t("enter") + this.$t("orderNum")
            },
            {
              name: () => this.$t("updateFile") + this.$t("files"),
              key: "files",
              component: "Upload",
              bind: {
                fileName: true,
                multiple: true,
                isButton: true,
                type: "select",
                accept: ".xlsx,.xls,.doc,.docx,.pdf,.jpg,.png,.jpeg,.gif"
              },
              methods: {
                beforeUpload({ file, row }) {
                  if (row["files"]) row["files"].push(file);
                  else row["files"] = [file];
                  return false;
                }
              }
            },
            {
              name: () => this.$t("uploaded"),
              key: "uploaded",
              solt: "UPLOADED"
            }
          ],
          table: {
            config: {
              align: "center",
              height: 300
            },
            footer: {
              show: true
            },
            fields: [
              {
                name: () => this.$t("FollowPerson"),
                key: "staff",
                align: "left",
                headerAlign: "left",
                tooltip: true,
                width: 130
              },
              {
                name: () => this.$t("FollowTime"),
                key: "create_time",
                align: "left",
                headerAlign: "left",
                tooltip: true,
                width: 150
              },
              {
                name: () => this.$t("FollowCase"),
                key: "message",
                align: "left",
                headerAlign: "left",
                tooltip: true
              },
              // {
              //   name: () => this.$t("Appendix"),
              //   align: "center",
              //   tooltip: true,
              //   width: 150,
              //   component: "Button",
              //   bind: {
              //     type: "primary",
              //     size: "small"
              //   },
              //   disabled: ({ row }) => {
              //     return (
              //       row.img && !row.img.length && row.doc && !row.doc.length
              //     );
              //   },
              //   methods: {
              //     render({ row }) {
              //       return "查看";
              //     },
              //     click({ row }) {
              //       this.$page.getModal("appendix").open(row);
              //     }
              //   }
              // },
              // {
              //   name: () => this.$t("FollowTime"),
              //   key: "create_time",
              //   align: "center",
              //   tooltip: true,
              //   width: 150
              // },
              // {
              //   name: () => this.$t("FollowPerson"),
              //   key: "staff",
              //   align: "center",
              //   tooltip: true,
              //   width: 130
              // },
              {
                name: () => this.$t("operation"),
                type: "btns",
                width: 150,
                fixed: "right",
                list: [
                  {
                    name: () => this.$t("Appendix"),
                    type: "appendix",
                    fnName: "appendix",
                    bind: {
                      type: "primary"
                    },
                    disabled: ({ row }) => {
                      return (
                        row.img && !row.img.length && row.doc && !row.doc.length
                      );
                    }
                  },
                  {
                    name: () => this.$t("delete"),
                    type: "delete",
                    fnName: "delete",
                    bind: {
                      type: "error"
                    }
                  }
                ],
                methods: {
                  appendix({ row }) {
                    this.getModal("appendix").open(row);
                  },
                  // update({ row }) {
                  //   row["method"] = "get";
                  //   let obj = {
                  //     method: "get",
                  //     id: row.id
                  //   };
                  //   this.handleRequestMethods("list", obj).then(res => {
                  //     this.getModal("add").setTitle(this.$t("update"));
                  //     let data = res.payload;
                  //     data["method"] = "put";
                  //     this.getModal("add").open(data);
                  //   });
                  // },
                  delete({ row }) {
                    this.$Modal.confirm({
                      title:
                        this.$t("whether") +
                        this.$t("confirm") +
                        this.$t("delete") +
                        this.$t("createTime") +
                        "：" +
                        row.create_time +
                        this.$t("assistOrder") +
                        "?",
                      onOk: () => {
                        this.handleRequestMethods(
                          "detail",
                          {
                            id: row.id,
                            method: "delete",
                            feedback_id: row.feedback_id
                          },
                          true
                        ).then(res => {
                          // this.$Message.success(res.data.msg);
                          let obj = {
                            method: "get",
                            feedback_id: row.feedback_id
                          };
                          this.getModal("detail").getList(obj);
                        });
                      }
                    });
                  }
                }
              }
            ]
          }
        }
      },
      header: {
        searchs: [
          {
            key: "dateType",
            component: "Select",
            bind: {
              style: "width:150px"
            },
            placeholder() {
              return this.$t("select") + this.$t("time") + this.$t("type");
            },
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType(["EXCEPTION_SELECT_TIME"])).data
                  .payload["EXCEPTION_SELECT_TIME"];
                field.options = res;
                searchForm["dateType"] = res[0].value;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              }
              // "on-change"({ searchForm }) {
              //   searchForm.startTime = searchForm.startTime
              //     ? this.$page.format.timeFormat(searchForm.startTime)
              //     : "";
              // }
            }
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              }
              // "on-change"({ searchForm }) {
              //   let time = this.$page.format.timeFormat(searchForm.endTime);
              //   if (time.slice(-8) === "00:00:00") {
              //     time = time.split(" ")[0] + " " + "23:59:59";
              //     searchForm["endTime"] = time;
              //   }
              // }
            }
          },
          {
            key: "clientId",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            clearable: true,
            options: [],
            config: { label: "account", value: "id" },
            methods: {
              async list({ field }) {
                let res = (await getAllClient()).data.payload;
                field.options = res.rows;
                this.$forceUpdate();
              }
            }
          },
					{
					  key: "exception_msg",
					  component: "Select",
					  bind: {
					    style: "width:150px",
					  },
					  placeholder() {
					    return this.$t("Abnormal Message");
					  },
					  options: [
							{value:1,label:this.$t('phoneError')},
							{value:2,label:this.$t('addressError')}
						],
					},
          {
            key: "codType",
            component: "Select",
            bind: {
              style: "width:150px"
            },
            placeholder() {
              return this.$t("select") + this.$t("order_type");
            },
            options: codType
            // config: { label: ({ row }) => this.$t(row.desc), value: "key" }
          },
          {
            key: "serviceId",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("serviceName");
            },
            clearable: true,
            options: [],
            config: { label: "account", value: "id" },
            methods: {
              async list({ field }) {
                let res = (await getUser({ standard: "CustomerService" })).data
                  .payload;
                field.options = res.rows;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "toCountry",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("countryCode");
            },
            clearable: true,
            options: [],
            config: { label: "code", value: "code" },
            methods: {
              async list({ field }) {
                let res = (await getCountry()).data.payload;
                field.options = res.rows;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "plan",
            component: "Select",
            bind: {
              style: "width:150px"
            },
            placeholder() {
              return this.$t("select") + this.$t("plan");
            },
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType(["EXCEPTION_SELECT_PLAN"])).data
                  .payload["EXCEPTION_SELECT_PLAN"];
                field.options = res;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "status",
            component: "Select",
            bind: {
              style: "width:150px"
            },
            placeholder() {
              return this.$t("select") + this.$t("planStatus");
            },
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType(["EXCEPTION_SELECT_STATUS"]))
                  .data.payload["EXCEPTION_SELECT_STATUS"];
                field.options = res;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "exceptionType",
            placeholder() {
              return this.$t("enter") + this.$t("exception_code");
            },
            component: "Input"
          },
          {
            key: "exceptionStatus",
            placeholder() {
              return this.$t("enter") + this.$t("exception_status");
            },
            component: "Input"
          },
          {
            key: "is_pickup",
            component: "Select",
            bind: {
              style: "width:150px"
            },
            placeholder() {
              return this.$t("whether") + this.$t("returnException");
            },
            options: pickupList
            // config: { label: ({ row }) => this.$t(row.desc), value: "key" }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1
              // autosize: { minRows: 2, maxRows: 2 }
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("reviseProcessStatus"),
              type: "finish",
              fnName: "finishFun",
              id: 539,
              disabled() {
                return !this.selectAll.length;
              },
              show: () => {
                return this.tabName == "YES";
              },
              bind: {
                type: "success"
              }
            },
            {
              name: () => this.$t("add") + this.$t("order_desc"),
              type: "remark",
              fnName: "remarkFun",
              id: 538,
              disabled() {
                return !this.selectAll.length;
              },
              show: () => {
                return this.tabName == "YES";
              },
              bind: {
                type: "warning"
              }
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            },
            finishFun() {
              let airway_number = this.selectAll.map(
                item => item.airway_number
              );
              this.getModal("finish").open({ airway_number });
            },
            remarkFun() {
              let airway_number = this.selectAll.map(
                item => item.airway_number
              );
              this.getModal("addRemark").open({ airway_number });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
          fixed: "left"
        },
        {
          name: () => this.$t("orderNum"),
          key: "airway_number",
          component: "Button",
          copy: true,
          align: "center",
          fixed: "left",
          bind: {
            type: "primary",
            size: "small"
          },
          showOverflow: false,
          width: 160,
          methods: {
            click({ row }) {
              this.$page.getModal("show").setTitle(row.airway_number);
              this.$page.getModal("show").open({ row });
            }
          }
        },
        {
          name: () => this.$t("outboundTime"),
          key: "outbound_time",
          align: "center",
          minWidth: 130
        },
        {
          name: () => this.$t("localFaction"),
          key: "deliver",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("warehouse_status"),
          key: "exception_type_msg",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("exception_msg"),
          key: "exception_msg",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("planStatus"),
          key: "status",
          align: "center",
          minWidth: 100,
          show: () => {
            return this.tabName == "YES";
          },
          methods: {
            render({ row }) {
              return this.$t(errorObj[row.status]);
            }
          }
        },
        {
          name: () => this.$t("plan"),
          key: "plan",
          align: "center",
          show: () => {
            return this.tabName == "YES";
          },
          minWidth: 100
        },
        {
          name: () => this.$t("is_pod"),
          key: "is_pod",
          align: "center",
          show: () => {
            return this.tabName == "YES";
          },
          minWidth: 100,
          methods: {
            render({ row }) {
              return this.$t(podType[row.is_pod]);
            }
          }
        },
        {
          name: () => this.$t("clientName"),
          key: "client_name",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("order_userRef"),
          key: "client_refer_code",
          align: "center",
          minWidth: 110
        },
        {
          name: () => this.$t("service") + this.$t("order_desc"),
          key: "remarks",
          align: "center",
          component: "a",
          minWidth: 110,
          methods: {
            async click({ row }) {
              let res = await this.$page.handleRequestMethods("remarkList", {
                airway_number: row.airway_number
              });
              this.$page.getModal("showRemark").open({ res }, function() {
                this.list = res.payload;
              });
            }
          }
        },
        {
          name: () => this.$t("service") + this.$t("processing_time"),
          key: "service_time",
          align: "center",
          minWidth: 130,
          methods: {
            render({ value }) {
              return ~~value ? this.format.timeFormat(value * 1000) : "-";
            }
          }
        },
        {
          name: () => this.$t("serviceName"),
          key: "service_name",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("target_country"),
          key: "to_country",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("exception_time"),
          key: "exception_time",
          align: "center",
          minWidth: 130
          // methods: {
          //   render({ value }) {
          //     return ~~value ? this.format.timeFormat(value * 1000) : "-";
          //   }
          // }
        },
        {
          name: () => this.$t("new_tracker_time"),
          key: "status_time",
          align: "center",
          minWidth: 130,
          methods: {
            render({ value }) {
              return ~~value ? this.format.timeFormat(value * 1000) : "-";
            }
          }
        },
        {
          name: () => this.$t("agentName"),
          key: "agent_name",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("order_refCode"),
          key: "agent_refer_code",
          align: "center",
          minWidth: 130
        },
        {
          name: () => this.$t("order_recivre"),
          key: "consignee_contact",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("order_address"),
          key: "consignee_address",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("order_phone"),
          key: "consignee_cellular",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("order_phone1"),
          key: "consignee_telephone",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("Appointment"),
          key: "reserve_time",
          align: "center",
          minWidth: 130
        },
        {
          name: () => this.$t("city_name"),
          key: "city_name",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("time_in_transit"),
          key: "time_in_transit",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("retired_times"),
          key: "retired_times",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("called_times"),
          key: "called_times",
          align: "center",
          minWidth: 130
        },
        {
          name: () => this.$t("refusal_number"),
          key: "refusal_number",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("exception_code"),
          key: "exception_code",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("subplan") + this.$t("time"),
          key: "plan_time",
          align: "center",
          minWidth: 150,
          methods: {
            render({ value }) {
              return ~~value ? this.format.timeFormat(value * 1000) : "-";
            }
          }
        }
      ]
    };
  }
};
</script>
